
import { mapMutations, mapState } from 'vuex';
import Product from '@/components/shop/product.vue';
import Skeleton from '@/components/ui/skeleton.vue';

export default {
  name: 'Shop',

  components: {
    Product,
    Skeleton,
  },

  layout: 'cat',

  data() {
    return {
      page: 1,
      lastPage: null,
      perPage: 10,
      loading: false,
      firstProducts: [],
      lists: [],
    };
  },

  computed: {
    ...mapState({
      shopInfo: (state) => state.options.field_shop_start,
      topLists: (state) => state.options.toplists,
      patientId: (state) => state.patientId,
    }),

    firstList() {
      return this.topLists.length ? this.topLists[0] : [];
    },

    otherLists() {
      const lists = [...this.topLists];
      lists.shift();
      return lists;
    },

    sortedLists() {
      return [...this.lists].sort((a, b) => a.index - b.index);
    },
  },

  async mounted() {
    try {
      this.firstProducts = await this.getProducts(this.firstList.products);
    } catch (_) {
      return this.$nuxt.error({ statusCode: 404 });
    }
    this.$bolev.metaEvent({
      patientId: this.patientId,
      type: 'pageView',
    });
    this.otherLists.forEach((list, k) => {
      this.getProducts(list.products).then((res) => {
        this.lists.push({
          index: k,
          title: list.title,
          subtitle: list.subtitle,
          products: res,
        });
      });
    });
  },

  methods: {
    ...mapMutations(['setProducts']),

    async getProducts(ids) {
      const { data } = await this.$wc.products({ ids });
      this.setProducts(data);
      return data;
    },
  },

  head() {
    return this.$seo.page('shop', this.$route.path);
  },
};
